var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronMiniRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.30649 14C8.09717 13.9988 7.89046 13.9533 7.69991 13.8667C7.49382 13.7758 7.31823 13.6276 7.19412 13.4396C7.07001 13.2517 7.00262 13.032 7 12.8068L7 7.194C7.00262 6.96878 7.07001 6.74908 7.19412 6.56114C7.31823 6.37319 7.49382 6.22494 7.69991 6.1341C7.93704 6.02209 8.20086 5.97895 8.46132 6.00959C8.72178 6.04023 8.96839 6.14343 9.17305 6.30742L12.5726 9.11381C12.7059 9.21994 12.8136 9.35478 12.8876 9.50828C12.9616 9.66177 13 9.82998 13 10.0004C13 10.1708 12.9616 10.339 12.8876 10.4925C12.8136 10.646 12.7059 10.7808 12.5726 10.887L9.17305 13.6934C8.928 13.8921 8.62199 14.0004 8.30649 14Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronMiniRight);
export default __webpack_public_path__ + "static/media/Chevron-Mini-Right.538b8f66586001df8cd1d00fa7e52396.svg";
export { ForwardRef as ReactComponent };